/**
 * Different policies for updating DSL attributes
 */
const DSL_UPDATE_POLICY = {
  Checkbox: Symbol("Checkbox"),
  Radio: Symbol("Radio")
};

module.exports = DSL_UPDATE_POLICY;



// WEBPACK FOOTER //
// ./src/js/constants/DSLUpdatePolicy.js